<div class="jumbotron jumbotron-visible"> <h2><i>Uh-oh.</i>We're not sure what that URL means.</h2> <div>We've made a note of this and we'll look into it.</div> <button class="btn btn-transparent" (click)="goBack()"> <span class="icon icon-chevron-left" style="font-size:smaller;margin-left:3px"></span> Go back a page </button> </div> 


// WEBPACK FOOTER //
// ng:///builds/lyonzy/shelvable/web/static/components/error-page/error-page.html